<template>
  <div class="wrapper">
    <div class="process-loading" v-if="loading">
      <div class="progress-icon"></div>
    </div>

    <div class="upper-bar" v-show="!loading">
      <div class="workflow-lefttop-bar">
        <button
          class="btn-back"
          v-b-tooltip.hover
          title="Zurück"
          @click="goBack()"
        >
          <i class="fas fa-chevron-left"></i>
        </button>

        <div class="name-wrapper">
          <input
            type="text"
            v-model="process.name"
            :disabled="!isUserHasAccess"
          />
        </div>
      </div>

      <div class="toolbar container">
        <div class="row">
          <div class="col-sm-6 p-0 d-flex justify-content-end">
            <div class="btn-group">
              <div
                class="button deploy"
                @click="publishProcess()"
                v-b-tooltip.hover
                title="Speichern"
              >
                <i class="fas fa-rocket"></i>
              </div>
              <div
                :class="{ 'button-loading': activeAction == 'publishing' }"
              ></div>
            </div>
            <div class="btn-group">
              <div
                class="button"
                @click="runProcess()"
                v-b-tooltip.hover
                title="Ausführen"
              >
                <i class="fas fa-play"></i>
              </div>

              <div
                :class="{ 'button-loading': activeAction == 'running' }"
              ></div>
            </div>
            <div class="btn-group" v-if="isUserHasAccess">
              <div
                class="button"
                @click="downloadFlowAsJson()"
                v-b-tooltip.hover
                title="Download"
              >
                <i class="fas fa-download"></i>
              </div>

              <div
                :class="{ 'button-loading': activeAction == 'downloading' }"
              ></div>
            </div>

            <div class="btn-group" v-if="isUserHasAccess">
              <div
                class="button delete"
                @click="toggleRemoveConfirmModal()"
                v-b-tooltip.hover
                title="Löschen"
              >
                <i class="fas fa-trash"></i>
              </div>
            </div>
            <div class="btn-group" v-if="isUserHasAccess">
              <div
                class="button"
                @click="toggleBrandSettingModal()"
                v-b-tooltip.hover
                title="Settings"
              >
                <i class="fa fa-cog"></i>
              </div>
              <div
                :class="{ 'button-loading': activeAction == 'brandSettings' }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="palette" class="palette" v-if="!loading">
      <div>
        <div v-for="taskClass in taskClasses" :key="taskClass.id">
          <!-- All task classes other than start -->
          <div
            class="task-wrapper"
            v-if="taskClass.name != 'Start' && taskClass.visible"
          >
            <div
              class="shape task"
              :class="taskClass.shape.type"
              :disabled="!isUserHasAccess"
              @click="
                isUserHasAccess
                  ? taskClass.active
                    ? { click: addTask(taskClass) }
                    : { click: toggleUnderConstruction() }
                  : {}
              "
            >
              <i
                v-if="!getImageFromAssetsTask.includes(taskClass.name)"
                :class="taskClass.icon"
              ></i>
              <img :src="taskClass.icon" v-else />
            </div>

            <div class="caption">{{ taskClass.caption }}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="taskProcessId"
      class="process"
      :style="{
        width: this.screenWidth,
        height: this.screenHeight,
      }"
    >
      <div class="process-inner" ref="taskBoard">
        <!-- Draggable Task miniatures -->
        <div
          v-for="(task, idx) in process.tasks"
          class="task-wrapper"
          :ref="task.id"
          :key="task.id"
          :style="getStyle(task)"
          :class="{
            error: errorTask == task.id,
            error: task.status == 'error',
          }"
        >
          <div
            v-if="editCaptionTaskId == task.id"
            class="task-caption"
            v-click-outside="toggleEditCaption"
          >
            <input
              class="title"
              v-model="task.caption"
              placeholder="Title eingeben..."
              ref="taskCaption"
            />
          </div>
          <div v-else class="task-caption" @click="toggleEditCaption(task.id)">
            {{ task.caption || task.name }}
          </div>
          <div
            class="shape task"
            :class="getShapeClass(task)"
            :id="`draggable${idx}`"
            @click="selectTask(task)"
            @mousemove="doDrag(task)"
            @mouseup="mouseUP(task, idx)"
          >
            <!-- before task dropzone -->

            <div
              class="custom-drag-area before"
              :class="{ 'dropped-task-class': mouseUpTaskId === task.id }"
              :id="task.id"
              type="before"
              v-if="idx !== 0"
            >
              <div class="icon">
                <i class="fa fa-arrow-down"></i>
              </div>
            </div>
            <div
              v-if="isAfterDropzoneVisible(idx, task)"
              class="custom-drag-area after"
              :class="{ 'dropped-task-class': mouseUpTaskId === task.id }"
              :id="task.id"
              type="after"
            >
              <div class="icon">
                <i class="fa fa-arrow-down"></i>
              </div>
            </div>
            <!-- true/false path dropzone -->
            <div v-if="task.name === 'Condition'">
              <div
                :id="task.id"
                v-if="task.path.truePath === true"
                type="true"
                class="custom-drag-area true"
                :class="{ 'dropped-task-class': mouseUpTaskId === task.id }"
              >
                <div class="icon">
                  <i class="fa fa-arrow-down"> true </i>
                </div>
              </div>
              <div
                :id="task.id"
                v-if="task.path.falsePath === true"
                type="false"
                class="custom-drag-area false"
                :class="{ 'dropped-task-class': mouseUpTaskId === task.id }"
              >
                <div class="icon">
                  <i class="fa fa-arrow-down"> false</i>
                </div>
              </div>
            </div>

            <!-- true/false label above task -->

            <i
              v-if="!getImageFromAssetsTask.includes(task.name)"
              :class="task.icon"
            ></i>
            <img :src="task.icon" v-else />
            <template v-if="isNotConditionTaskPathExist(task)">
              <span class="condition-state" :class="{ false: !task.pathType }"
                >{{ task.pathType }}
              </span>
            </template>

            <ul class="tools">
              <li v-show="errorTask == task.id" class="error-icon">
                <a><i class="fas fa-exclamation-circle danger"></i></a>

                <div class="error-message">{{ errorDescription }}</div>
              </li>
              <li
                v-if="task.shape.selected && isUserHasTaskEditAccess(task)"
                v-b-tooltip.hover
                title="Bearbeiten"
              >
                <a><i class="fas fa-edit" @click="taskSetting(task)"></i></a>
              </li>
              <li
                v-if="
                  task.name != 'Start' && task.shape.selected && isUserHasAccess
                "
                v-b-tooltip.hover
                title="Löschen"
              >
                <a><i class="fas fa-trash" @click="removeTask(task)"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Task Modal components, there is a component for every task in the flow -->
    <div v-for="(task, idx) in process.tasks" :key="task.id">
      <component
        v-if="task.active"
        :is="task.name"
        :settings="process.settings"
        :flow-id="process.id"
        :task="task"
        :process="process"
        :databaseSchema="databaseSchema"
        :showDatabaseMissing="showDatabaseMissing"
        :isUserHasAccess="isUserHasAccess"
        @close="hideTaskUI(task)"
        @resetErrorMessage="resetErrorMessage()"
        @setShowResultInForm="setShowResultInForm"
        @conditionBuilderResponse="onConditionBuilderResponse"
        :isTableIdArray="isTableIdArray"
        :getFileNamesFromProps="getFileNamesFromProps"
      ></component>

      <modal-box
        v-if="modalBox.isModalBoxVisible"
        class="modal-window"
        :title="modalBox.title"
        :message="modalBox.msg"
        :buttonCaption="modalBox.btnCaption"
        @close="hideModalBox"
      />
      <deleteConditionModal
        v-if="showDeletePopup === task.id"
        :showDeletePopup="showDeletePopup"
        :t="task"
        :process="process"
        :idx="idx"
        @close="closeDeletePopup"
      />
    </div>
    <InputBox
      v-show="this.showInputBox"
      :input="this.process.name"
      :title="'Name für das Prozess eingeben'"
      :inputType="'name'"
      :buttonCaption="'Speichern'"
      @close="hideInputBox()"
    >
    </InputBox>
    <htmlViewer
      v-if="htmlViewer.isHtmlViewerVisible"
      :myHtml="htmlViewer.html"
      @close="hideHtmlViewer()"
    >
    </htmlViewer>
    <under-construction
      v-show="this.isUnderConstructionVisible"
      @close="toggleUnderConstruction()"
    >
    </under-construction>
    <BrandSettingModel
      :isBrandSettingModelOpen="isBrandSettingModelOpen"
      :process="process"
      v-if="isBrandSettingModelOpen"
      @saveBrandSettings="saveBrandSettingsToProcess"
      @close="toggleBrandSettingModal"
    >
    </BrandSettingModel>
    <RemoveConfirmModal
      v-if="isRemoveConfirmVisible"
      @close="toggleRemoveConfirmModal()"
      :flows="this.process"
      :id="this.process.id"
      :name="this.process.name"
      actionType="remove"
      resourceType="flow"
      @confirmRemove="removeFlow"
    >
    </RemoveConfirmModal>
  </div>
</template>

<script>
import Start from './tasks/start.vue';
import Database from './tasks/Database.vue';
import TsOperations from './tasks/ts-operations.vue';
import Pricing from './tasks/pricing.vue';
import AddValue from './tasks/addValue.vue';
import Email from './tasks/email.vue';
import API from './tasks/API.vue';
import Code from './tasks/code.vue';
import End from './tasks/end.vue';
import Ftp from './tasks/ftp.vue';
import ReadTS from './tasks/ReadTS.vue';
import TSMath from './tasks/TSMath.vue';
import HTML from './tasks/htmlEditor.vue';
import InputBox from './modals/inputBox.vue';
import htmlViewer from './modals/htmlViewer.vue';
import UnderConstruction from './modals/underConstruction.vue';
import PageBuilder from './tasks/pageBuilderWarp.vue';
import Condition from './tasks/conditionBuilderWrap.vue';
import Logic from './tasks/logicBuilderWrap.vue';
import { Auth } from 'aws-amplify';
import deleteConditionModal from './modals/deleteConditionModal.vue';
import LoadingSpinner from './widgets/LoadingSpinner.vue';
import RemoveConfirmModal from './modals/removeConfirmModal.vue';
import { workFlowAccessLevel } from '../enum/auth.enum';
import { mapGetters, mapActions } from 'vuex';
import { jsPlumb } from 'jsplumb';
import BrandSettingModel from './modals/BrandSettingModel.vue';
import {
  getWorkFlowById,
  deleteWorkflowById,
} from '../services/workflow.service.js';
import { getFlowLastId, isObjectType } from '../utils/helpers';
import Redirect from './tasks/redirect.vue';

export default {
  name: 'Process',
  data() {
    return {
      selectedConditionImg: require('../assets/img/condition_pink.svg'),
      showDropzoneForCondition: true,
      mouseUpTaskId: null,
      hideDragArea: '',
      loading: true,
      dragging: false,
      lastID: null,
      activeAction: null,
      referenceProcess: null,
      unsavedDataHandler: null,
      isDuplicating: false,
      htmlViewer: {
        isHtmlViewerVisible: false,
        html: null,
      },
      showDeletePopup: null,
      lastTokenRefresh: null,
      modalBox: {
        isModalBoxVisible: false,
        title: '',
        msg: [],
        btnCaption: 'Schliessen',
      },
      isUnderConstructionVisible: false,
      errorTask: null,
      errorDescription: null,
      userHasOpened: {
        Start: false,
        Database: false,
        TsOperations: false,
        Pricing: false,
        AddValue: false,
        Report: false,
        Email: false,
        Code: false,
        End: false,
        Ftp: false,
        ReadTS: false,
        TSMath: false,
        Redirect: false,
      },
      taskClasses: [
        {
          id: 1,
          active: true,
          visible: false,
          name: 'Start',
          caption: 'Start',
          status: 'success',
          icon: 'fa fa-play',
          ui: 'Start',
          shape: {
            type: 'circle',
            x: 300,
            y: 500,
            width: 99,
            height: 99,
          },
          props: {
            trigger: 'formTrigger',
            timeTrigger: {
              freq: 'H',
              date: '01.03.2020',
              time: '08:00',
            },
            formTrigger: {
              id: null,
              title: null,
              Description: null,
              elements: [],
              structure: {
                tabs: [
                  {
                    id: 0,
                    rows: [
                      {
                        id: 0,
                        cols: [
                          {
                            id: 0,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              fullWidth: false,
            },
            eventTrigger: null,
            emailTrigger: null,
          },
        },
        {
          id: 2,
          name: 'Database',
          active: true,
          visible: true,
          caption: 'Daten',
          status: 'success',
          icon: 'fas fa-database',
          ui: 'Database',
          shape: {
            type: 'rectangle',
            x: 300,
            y: 500,
            width: 215,
            height: 72,
          },
          props: {
            operation: null,
            database: null,
            item: {},
          },
        },
        {
          id: 5,
          active: false,
          visible: false,
          name: 'Pricing',
          caption: 'Preis',
          status: 'success',
          icon: 'fa fa-euro-sign',
          ui: 'Pricing',
          shape: {
            type: 'rectangle',
            x: 300,
            y: 500,
            width: 215,
            height: 72,
          },
          props: null,
        },
        {
          id: 8,
          active: true,
          visible: true,
          name: 'End',
          caption: 'Ende',
          status: 'success',
          icon: 'fa fa-check',
          ui: 'End',
          shape: {
            type: 'circle',
            x: 300,
            y: 500,
            width: 99,
            height: 99,
          },
          input: null,
          props: {
            successURL: '',
            errorURL: '',
            successHTML: '',
            errorHTML: '',
          },
          output: null,
        },
        {
          id: 9,
          name: 'AddValue',
          active: true,
          visible: false,
          caption: 'Speichern',
          status: 'success',
          icon: 'fa fa-save',
          ui: 'AddValue',
          shape: {
            type: 'rectangle',
            x: 300,
            y: 500,
            width: 215,
            height: 72,
          },
          props: null,
        },
        {
          id: 10,
          active: true,
          visible: true,
          name: 'Email',
          caption: 'E-Mail',
          status: 'success',
          icon: 'fa fa-envelope',
          ui: 'Email',
          shape: {
            type: 'rectangle',
            x: 300,
            y: 500,
            width: 215,
            height: 72,
          },
          input: null,
          props: {
            from: '',
            receiver: '',
            cc: '',
            bcc: '',
            subject: '',
            message: '<br>',
            attachment: [],
          },
          output: null,
        },
        {
          id: 11,
          name: 'Report',
          active: true,
          visible: false,
          caption: 'Bericht',
          status: 'success',
          icon: 'fas fa-file',
          ui: 'Report',
          shape: {
            type: 'rectangle',
            x: 300,
            y: 500,
            width: 215,
            height: 72,
          },
          props: {
            Heading: '',
            Subhead: '',
            Description: '',
            Charts: [
              {
                idSerie: 0,
              },
              {
                idSerie: 0,
              },
            ],
          },
        },
        {
          id: 12,
          active: false,
          visible: false,
          name: 'Ftp',
          caption: 'FTP',
          status: 'success',
          icon: 'fas fa-folder-open',
          ui: 'Ftp',
          shape: {
            type: 'rectangle',
            x: 300,
            y: 500,
            width: 215,
            height: 72,
          },
          input: null,
          props: {
            url: null,
            user: null,
            password: null,
          },
          output: null,
        },
        {
          id: 13,
          name: 'ReadTS',
          active: true,
          visible: false,
          caption: 'Zeitreihe',
          status: 'success',
          icon: 'fas fa-chart-area',
          ui: 'ReadTS',
          shape: {
            type: 'rectangle',
            x: 300,
            y: 500,
            width: 99,
            height: 99,
          },
          input: null,
          props: null,
          output: null,
        },
        {
          id: 14,
          active: true,
          visible: false,
          name: 'TSMath',
          caption: 'Kalkulieren',
          status: 'success',
          icon: 'fas fa-calculator',
          ui: 'TSMath',
          shape: {
            type: 'rectangle',
            x: 300,
            y: 500,
            width: 99,
            height: 99,
          },
          input: null,
          props: null,
          output: null,
        },
        {
          id: 15,
          active: true,
          visible: true,
          name: 'Code',
          caption: 'Code',
          status: 'success',
          icon: 'fa fa-code',
          ui: 'Code',
          shape: {
            type: 'rectangle',
            x: 300,
            y: 500,
            width: 215,
            height: 72,
          },
          input: null,
          props: {
            code: '# Insert your code here \n',
            language: 'py',
          },
          output: null,
        },
        {
          id: 16,
          active: true,
          visible: true,
          name: 'HTML',
          caption: 'Page',
          icon: 'fas fa-file',
          status: 'success',
          ui: 'HTML',
          shape: {
            type: 'rectangle',
            x: 300,
            y: 500,
            width: 215,
            height: 72,
          },
          input: null,
          props: {
            message: '',
            markdown: '',
            templateUrl: '',
            filename: 'Report',
          },
          output: null,
        },
        {
          id: 17,
          active: false,
          visible: false,
          name: 'API',
          caption: 'API',
          status: 'success',
          icon: 'fa fa-plug',
          ui: 'Email',
          shape: {
            type: 'rectangle',
            x: 300,
            y: 500,
            width: 215,
            height: 72,
          },
          input: null,
          props: {
            from: '',
            receiver: '',
            cc: '',
            bcc: '',
            subject: '',
            message: '<br>',
            attachment: [],
          },
          output: null,
        },
        {
          id: 18,
          active: true,
          visible: true,
          name: 'Condition',
          caption: 'Kondition',
          status: 'success',
          icon: require('../assets/img/condition.svg'),
          ui: 'Condition',
          shape: {
            type: 'rectangle',
            x: 300,
            y: 500,
            width: 215,
            height: 72,
          },
          path: {
            truePath: true,
            falsePath: true,
          },
          input: null,
          props: { conditions: null },
          output: null,
        },
        {
          id: 19,
          name: 'PageBuilder',
          active: true,
          visible: true,
          caption: 'Report',
          status: 'success',
          icon: 'fas fa-chart-area',
          ui: 'Code',
          shape: {
            type: 'rectangle',
            x: 300,
            y: 500,
            width: 99,
            height: 99,
          },
          input: null,
          props: { jsonContent: null, htmlContent: null, reportName: null },
          output: null,
        },
        {
          id: 20,
          name: 'Logic',
          active: true,
          visible: true,
          caption: 'Logik',
          status: 'success',
          icon: require('../assets/img/logic.svg'),
          ui: 'Code',
          shape: {
            type: 'rectangle',
            x: 300,
            y: 500,
            width: 99,
            height: 99,
          },
          input: null,
          props: { defaultStatementAndLogicNodes: null },
          output: null,
        },
        {
          id: 21,
          active: true,
          visible: true,
          name: 'Redirect',
          caption: 'Weiterleiten',
          status: 'success',
          icon: 'fa fa-directions',
          ui: 'Redirect',
          shape: {
            type: 'circle',
            x: 300,
            y: 500,
            width: 99,
            height: 99,
          },
          input: null,
          props: {
            redirect: '',
          },
          output: null,
        },
      ],
      process: {
        id: null,
        name: null,
        tasks: [],
      },
      selectedTask: {
        previousTaskId: null,
        input: [],
        output: [],
      },
      input: [],
      tools: {
        justPublished: false,
        justSaved: false,
        justRunned: false,
        message: null,
        error: false,
      },
      showInputBox: false,
      jsonTypes: [
        'timeseries', // timeseries is needed for backwards compatiblility
        'loadprofile',
        'custom',
        'object',
        'objectlist',
      ],
      listTypes: ['checkbox'],
      requestError: null,
      dragDrop: false,
      flowPermission: {},
      getImageFromAssetsTask: ['Condition', 'Logic'],
      editCaptionTaskId: '',
      isBrandSettingModelOpen: false,
      nonSwappableTasks: ['Start', 'Condition'],
      isRemoveConfirmVisible: false,
    };
  },
  props: {
    databases: Array,
    processID: String,
  },
  methods: {
    ...mapActions({
      changeSingleFlowName: 'changeSingleFlowNameAction',
      removeSingleFlowById: 'removeSingleFlowByIdAction',
    }),
    getFileNamesFromProps(taskName, taskVariable, taskid) {
      const filteredTask = this.process.tasks
        .filter((el) => el.name.trim() === taskName && el.id !== taskid)
        .map((ele) => ele.props[taskVariable]);

      return filteredTask && filteredTask.length ? filteredTask : [];
    },
    getPreviousOutput(task) {
      const previousTaskId = task.previousTaskId;
      if (previousTaskId) {
        const t = this.process.tasks.filter(
          (item) => item.id == previousTaskId
        );
        if (t.length > 0) return t[0].output;
      } else {
        return [];
      }
    },
    async checkEditPermission(id) {
      const url = `${process.env.VUE_APP_DATA_API}/flow/iam/${id}`;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      try {
        const response = await fetch(url, {
          headers: myHeaders,
          method: 'GET',
        });
        if (response.status != 200) throw new Error(response.statusText);
        const json = await response.json();
        this.flowPermission = json.find(
          (user) => user.identity == this.user.username
        );
        if (
          json.filter(
            (e) =>
              e.identity == this.user.username && e.access_level != 'execute'
          ).length > 0
        )
          return true;
        else {
          // If user has no access, redirect to process-list
          this.$router.push({
            path: 'process-list',
          });
        }
      } catch (err) {
        this.$router.push({
          path: 'process-list',
        });
      }
    },
    async fetchData() {
      this.loading = true;

      // Get flow
      this.process = await this.getFlow(this.processID);
      // Check user permission
      if (this.process.owner != this.user.username)
        await this.checkEditPermission(this.processID);

      this.referenceProcess = JSON.stringify(this.process);
      this.loading = false;

      // Add start task and handle files
      this.addMissingAttributesToFlow();
      this.handleFileinputAtStart();
    },
    async getFlow(id) {
      const response = await getWorkFlowById(id);
      if (response && response.status === 200) {
        const { data } = response;
        if (!data.settings.hasOwnProperty('btnCaption'))
          data.settings.btnCaption = 'Starten';
        if (!data.settings.hasOwnProperty('loadingCaption'))
          data.settings.loadingCaption = 'Ladevorgang läuft...';
        if (!data.settings.hasOwnProperty('fullWidth'))
          data.settings.fullWidth = false;
        if (!data.settings.hasOwnProperty('brandingColor'))
          data.settings.brandingColor = '#000';

        return response.data;
      }
    },
    newID() {
      return getFlowLastId(this);
    },
    addTask(TaskClass) {
      this.userOpenedTask(TaskClass.name);

      // Get last task in flow
      var offsetX = 450;
      var offsetY = 350;

      const tasksCount = this.process.tasks.length;
      if (this.process.tasks.length > 0) {
        const lastTask = this.process.tasks[tasksCount - 1];
        if (lastTask.pathType === false) {
          offsetX = lastTask.shape.x + 250;
        } else {
          offsetX = lastTask.shape.x + 150;
        }
        // Make arrows zigzag
        offsetY = lastTask.shape.y;
        offsetY += tasksCount % 2 != 0 ? -150 : 150;
      }

      // Create new task with offset to the last task
      var task = {
        id: this.newID(),
        name: TaskClass.name,
        caption: TaskClass.caption,
        icon: TaskClass.icon,
        ui: TaskClass.ui,
        active: true,
        shape: {
          type: TaskClass.shape.type,
          x: offsetX,
          y: offsetY,
          width: TaskClass.shape.width,
          height: TaskClass.shape.height,
          selected: false,
        },
        props: JSON.parse(JSON.stringify(TaskClass.props)),
        input: [],
        output: [],
      };

      if (TaskClass.name === 'Condition') {
        task.path = {
          truePath: true,
          falsePath: true,
        };
      }

      this.process.tasks.push(task);

      if (tasksCount > 0) {
        const obj = this.process.tasks.find((item) => item.id === task.id);
        const idx = this.process.tasks.findIndex((item) => item.id === obj.id);

        // set X and Y position and previousTaskId for task
        if (
          idx > 0 &&
          this.process.tasks[idx - 1].name === 'Condition' &&
          this.process.tasks[idx - 1].pathType !== false
        ) {
          if (idx > 1 && this.process.tasks[idx - 2].name === 'Condition') {
            task.previousTaskId = this.process.tasks[idx - 2].id;
            task.pathType = false;

            this.process.tasks[idx - 2].path.falsePath = false;
            task.shape = {
              type: TaskClass.shape.type,
              x: this.process.tasks[idx - 2].shape.x + 250,
              y:
                this.process.tasks[idx - 2].shape.y + 100 < 0
                  ? 0
                  : this.process.tasks[idx - 2].shape.y + 100,
              width: 215,
              height: 62,
              selected: false,
            };
          } else {
            task.previousTaskId = this.process.tasks[idx - 1].id;
            task.pathType = true;

            this.process.tasks[idx - 1].path.truePath = false;
            task.shape = {
              type: TaskClass.shape.type,
              x: this.process.tasks[idx - 1].shape.x + 250,
              y:
                this.process.tasks[idx - 1].shape.y - 100 < 0
                  ? 0
                  : this.process.tasks[idx - 1].shape.y - 50,
              width: 215,
              height: 62,
              selected: false,
            };
          }
        } else if (
          idx > 1 &&
          this.process.tasks[idx - 2].name === 'Condition' &&
          this.process.tasks[idx - 1].pathType !== false
        ) {
          task.previousTaskId = this.process.tasks[idx - 2].id;

          task.pathType = false;

          this.process.tasks[idx - 2].path.falsePath = false;
          task.shape = {
            type: TaskClass.shape.type,
            x: this.process.tasks[idx - 2].shape.x + 250,
            y:
              this.process.tasks[idx - 2].shape.y + 100 < 0
                ? 0
                : this.process.tasks[idx - 2].shape.y + 100,
            width: 215,
            height: 62,
            selected: false,
          };
        } else {
          task.previousTaskId = this.process.tasks[tasksCount - 1].id;
          if (this.process.tasks[idx - 1].name === 'Condition') {
            task.pathType = true;

            this.process.tasks[idx - 1].path.truePath = false;
            task.shape = {
              type: TaskClass.shape.type,
              x: offsetX + 150,
              y: offsetY - 150,
              width: 215,
              height: 62,
              selected: false,
            };
          }
        }
      } else {
        task.previousTaskId = null;
      }
      this.selectedTask = task;
      // set input output for the task
      if (task.previousTaskId) {
        const previousTask = this.process.tasks.filter(
          (t) => t.id == task.previousTaskId
        )[0];
        task.input = previousTask.output;
        task.output = previousTask.output;
      } else task.input = [];
    },

    userOpenedTask(name) {
      this.userHasOpened[name] = true;
    },
    selectTask(task) {
      // Check token
      this.checkRefreshToken();

      //set selected task as task
      this.selectedTask = task;

      //unselect all tasks
      this.process.tasks.forEach((item) => (item.shape.selected = false));

      //select the task that match the id of selectedtask
      const t = this.process.tasks.filter(
        (item) => item.id == this.selectedTask.id
      )[0];

      // Prevent error when delete flow
      if (t != undefined) {
        t.input = this.getPreviousOutput(t);
        t.shape.selected = true;
      }
    },
    taskSetting(task) {
      this.selectedTask = task;
      this.userOpenedTask(task.name);
      this.showTaskUI(task);
    },
    hideTaskUI(task) {
      task.active = false;
    },
    hideInputBox() {
      this.showInputBox = false;
    },
    showTaskUI(task) {
      task.input = this.getPreviousOutput(task);
      task.active = true;
    },
    getStyle(task) {
      const styles = task.styles ? task.styles : {};
      return {
        left: task.shape.x < 0 ? 0 : task.shape.x + 'px',
        top: task.shape.y < 0 ? 0 : task.shape.y + 'px',
        ...styles,
      };
    },
    getSVGContainerStyle(task, prevTask) {
      const leftElem = task.shape.x < prevTask.shape.x ? task : prevTask;
      const topElem = task.shape.y < prevTask.shape.y ? task : prevTask;
      const y1 = this.getArrowY1(task, prevTask);
      const y2 = this.getArrowY2(task, prevTask);
      return {
        position: 'absolute',
        width: this.getArrowX2(task, prevTask) + 'px',
        height: (y1 > y2 ? y1 : y2) + 'px',
        left:
          leftElem.shape.x + (leftElem.shape.width * 0) / 2 < 0
            ? 0
            : leftElem.shape.x + (leftElem.shape.width * 0) / 2 + 'px',
        top:
          topElem.shape.y + topElem.shape.height / 2 < 0
            ? 0
            : topElem.shape.y + topElem.shape.height / 2 + 'px',
      };
    },
    /* the x coordinate of the left limb of the line */
    getArrowX1() {
      return 0;
    },
    getArrowX2(task, prevTask) {
      const leftElem = task.shape.x < prevTask.shape.x ? task : prevTask;
      return (
        Math.abs(task.shape.x - prevTask.shape.x) -
        (leftElem.shape.width * 0) / 2
      );
    },
    getArrowY1(task, prevTask) {
      const leftElem = task.shape.x < prevTask.shape.x ? task : prevTask;
      const topElem = task.shape.y < prevTask.shape.y ? task : prevTask;
      return leftElem != topElem
        ? Math.abs(task.shape.y - prevTask.shape.y) -
            (topElem.shape.height * 0) / 2
        : 0;
    },
    getArrowY2(task, prevTask) {
      const leftElem = task.shape.x < prevTask.shape.x ? task : prevTask;
      const topElem = task.shape.y < prevTask.shape.y ? task : prevTask;
      return leftElem === topElem
        ? Math.abs(task.shape.y - prevTask.shape.y) -
            (topElem.shape.height * 0) / 2
        : 0;
    },
    smallest(a, b) {
      return a < b ? a : b;
    },
    largest(a, b) {
      return a > b ? a : b;
    },

    findDropZonePosition(task) {
      var type;
      const dropX = task.shape.x;
      const dropY = task.shape.y;
      const obj = this.process.tasks.find((item) => {
        if (
          dropX >= item.shape.x - 120 &&
          dropX < item.shape.x - 30 &&
          dropY >= item.shape.y - 50 &&
          dropY < item.shape.y + 50
        ) {
          type = 'before';
          return item;
        } else if (
          dropX >= item.shape.x + 30 &&
          dropX < item.shape.x + 120 &&
          dropY >= item.shape.y - 50 &&
          dropY < item.shape.y + 50
        ) {
          type = 'after';
          return item;
        } else if (
          dropX < item.shape.x + 150 &&
          dropX >= item.shape.x + 100 &&
          dropY >= item.shape.y + 8 &&
          dropY < item.shape.y + 100
        ) {
          type = false;
          return item;
        } else if (
          dropX < item.shape.x + 150 &&
          dropX >= item.shape.x + 100 &&
          dropY >= item.shape.y - 90 &&
          dropY < item.shape.y + 5
        ) {
          type = true;
          return item;
        } else {
          return;
        }
      });
      if (type === true || type === false) {
        if (
          obj.name === 'Condition' &&
          ((type === true && obj.path.truePath) ||
            (type === false && obj.path.falsePath))
        ) {
          return [obj, type];
        } else {
          return [null, type];
        }
      } else if (type == 'after') {
        if (
          !this.process.tasks.some((item) => item.previousTaskId == obj.id) &&
          !this.nonSwappableTasks.includes(task.name)
        )
          return [obj, type];
        else return [null, type];
      } else {
        return [obj, type];
      }
    },
    doDrag(task) {
      if (this.nonSwappableTasks.includes(task.name)) return;
      const dropX = task.shape.x;
      const dropY = task.shape.y;

      const obj = this.process.tasks.find((item) => {
        if (
          dropX >= item.shape.x - 120 &&
          dropX < item.shape.x + 100 &&
          dropY >= item.shape.y - 120 &&
          dropY < item.shape.y + 80 &&
          item.id != task.id
        ) {
          return item;
        }
      });

      if (obj) {
        this.mouseUpTaskId = obj.id;
      } else {
        this.mouseUpTaskId = null;
      }
    },

    mouseUP(task, oldIdx) {
      this.hideDragArea = '';
      const value = this.findDropZonePosition(task);
      const obj = value[0];
      const type = value[1];

      if (obj) {
        if (
          !this.nonSwappableTasks.includes(task.name) &&
          obj.name !== 'Start' &&
          task.name !== 'End' &&
          obj.name !== 'End'
        ) {
          const newIdx = this.process.tasks.indexOf(obj);
          // set previousId
          if (
            this.process.tasks[oldIdx + 1] &&
            this.process.tasks[oldIdx + 1].pathType !== false
          ) {
            this.process.tasks[oldIdx + 1].previousTaskId =
              this.process.tasks[oldIdx].previousTaskId;
          }

          // if old position task is true/false path
          if (
            this.process.tasks[oldIdx].pathType === true ||
            this.process.tasks[oldIdx].pathType === false
          ) {
            if (this.process.tasks[oldIdx + 1]) {
              if (this.process.tasks[oldIdx + 1].pathType === true) {
                const parentTask = this.process.tasks.filter(
                  (item) =>
                    item.id === this.process.tasks[oldIdx + 1].previousTaskId
                );
                parentTask[0].path.falsePath = true;
                this.process.tasks[oldIdx + 1].pathType = true;
              } else if (this.process.tasks[oldIdx + 1].pathType === false) {
                this.process.tasks[oldIdx - 1].path.truePath = true;
                this.process.tasks[oldIdx + 1].pathType = false;
              } else {
                this.process.tasks[oldIdx + 1].pathType =
                  this.process.tasks[oldIdx].pathType;
              }
            } else {
              if (this.process.tasks[oldIdx].pathType === true) {
                this.process.tasks[oldIdx - 1].path.truePath = true;
              } else {
                const parentTask = this.process.tasks.filter(
                  (item) =>
                    item.id === this.process.tasks[oldIdx].previousTaskId
                );
                parentTask[0].path.falsePath = true;
              }
            }
            delete this.process.tasks[oldIdx].pathType;
          }

          // set task according to the dropzone position
          if (type === 'before') {
            this.process.tasks.splice(oldIdx, 1);
            if (oldIdx < newIdx) {
              this.process.tasks.splice(newIdx - 1, 0, task);
            } else {
              this.process.tasks.splice(newIdx, 0, task);
            }
          } else if (type === 'after') {
            this.process.tasks.splice(oldIdx, 1);

            this.process.tasks.splice(newIdx + 1, 0, task);
          }
          // true path dropzone
          else if (type === true && obj.name === 'Condition') {
            this.process.tasks.splice(oldIdx, 1);
            if (oldIdx < newIdx) {
              this.process.tasks.splice(newIdx, 0, task);
              this.process.tasks[newIdx].pathType = true;
            } else {
              this.process.tasks.splice(newIdx + 1, 0, task);
              this.process.tasks[newIdx + 1].pathType = true;
            }
            obj.path.truePath = false;
          }
          // false path dropzone
          else if (type === false && obj.name === 'Condition') {
            this.process.tasks.splice(oldIdx, 1);
            if (oldIdx < newIdx) {
              if (!obj.path.truePath) {
                this.process.tasks.splice(newIdx + 1, 0, task);

                this.process.tasks[newIdx + 1].pathType = false;
              } else {
                this.process.tasks.splice(newIdx, 0, task);

                this.process.tasks[newIdx].pathType = false;
              }
            } else {
              if (!obj.path.truePath) {
                this.process.tasks.splice(newIdx + 2, 0, task);

                this.process.tasks[newIdx + 2].pathType = false;
              } else {
                this.process.tasks.splice(newIdx + 1, 0, task);

                this.process.tasks[newIdx + 1].pathType = false;
              }
            }
            obj.path.falsePath = false;
          }

          // if obj is true/false path then set and delete true/false label
          if (
            (obj.pathType === true ||
              (obj.pathType === false && type === 'before')) &&
            type != 'after'
          ) {
            if (oldIdx < newIdx) {
              this.process.tasks[newIdx - 1].pathType = obj.pathType;
            } else {
              this.process.tasks[newIdx].pathType = obj.pathType;
            }
            delete obj.pathType;
          }

          //  set previous id for new position of task
          if (oldIdx < newIdx) {
            if ((type === true || type === false) && obj.name === 'Condition') {
              this.process.tasks[newIdx].previousTaskId =
                this.process.tasks[newIdx - 1].id;
              if (this.process.tasks[newIdx + 1]) {
                if (type === false) {
                  if (!obj.path.truePath) {
                    const parentTask = this.process.tasks.filter(
                      (item) => obj.id === item.previousTaskId
                    );
                    this.process.tasks[newIdx + 1].previousTaskId =
                      parentTask[0].previousTaskId;
                  } else {
                    this.process.tasks[newIdx + 1].previousTaskId =
                      this.process.tasks[newIdx].id;
                  }
                } else if (type === true) {
                  const parentTask = this.process.tasks.filter(
                    (item) => obj.id === item.previousTaskId
                  );
                  this.process.tasks[newIdx + 1].previousTaskId =
                    parentTask[0].previousTaskId;
                } else {
                  this.process.tasks[newIdx + 1].previousTaskId =
                    this.process.tasks[newIdx].id;
                }
              }
            } else if (type === 'before') {
              this.process.tasks[newIdx - 1].previousTaskId =
                obj.previousTaskId;
              this.process.tasks[newIdx].previousTaskId =
                this.process.tasks[newIdx - 1].id;
            } else if (type === 'after') {
              this.process.tasks[newIdx].previousTaskId =
                this.process.tasks[newIdx - 1].id;
            }
          } else {
            if ((type === true || type === false) && obj.name === 'Condition') {
              if (this.process.tasks[newIdx + 1]) {
                const parentTask = this.process.tasks.filter(
                  (item) =>
                    item.id === this.process.tasks[newIdx + 1].previousTaskId
                );
                this.process.tasks[newIdx + 1].previousTaskId =
                  parentTask[0].id;
              }
              if (this.process.tasks[newIdx + 2]) {
                const parentTask = this.process.tasks.filter(
                  (item) =>
                    item.id === this.process.tasks[newIdx + 2].previousTaskId
                );
                this.process.tasks[newIdx + 2].previousTaskId =
                  parentTask[0].id;
              }
            } else if (type === 'before') {
              this.process.tasks[newIdx].previousTaskId = obj.previousTaskId;
              this.process.tasks[newIdx + 1].previousTaskId =
                this.process.tasks[newIdx].id;
            }
          }
        }
      }
    },

    removeTask(task) {
      const indx = this.process.tasks.indexOf(task);
      const isLastTask = indx + 1 == this.process.tasks.length;
      // Reset previousTaskId of next task before delete selected task
      if (!isLastTask) {
        if (task.name !== 'Condition') {
          const parentTask = this.process.tasks.filter(
            (item) => item.id === task.previousTaskId
          );
          if (task.pathType === true) {
            if (this.process.tasks[indx + 1].pathType === false) {
              parentTask[0].path.truePath = true;
            } else {
              this.process.tasks[indx + 1].pathType = true;

              this.process.tasks[indx + 1].previousTaskId = parentTask[0].id;
            }
          } else if (task.pathType === false) {
            this.process.tasks[indx + 1].pathType = false;

            this.process.tasks[indx + 1].previousTaskId = parentTask[0].id;
          } else {
            this.process.tasks[indx + 1].previousTaskId =
              this.process.tasks[indx].previousTaskId;
          }
        }
      } else {
        const parentTask = this.process.tasks.filter(
          (item) => item.id === task.previousTaskId
        );
        if (task.pathType === true) {
          parentTask[0].path.truePath = true;
        } else if (task.pathType === false) {
          parentTask[0].path.falsePath = true;
        }
      }
      // delete task [for the condition task show modal]
      if (task.name === 'Condition') {
        const taskIdx = this.process.tasks.findIndex(
          (item) => item.id === task.id
        );
        if (taskIdx === this.process.tasks.length - 1) {
          const parentTask = this.process.tasks.filter(
            (item) => item.id === task.previousTaskId
          );
          if (task.pathType === true) {
            parentTask[0].path.truePath === true;
          } else if (task.pathType === false) {
            parentTask[0].path.falsePath === true;
          }
          this.process.tasks.splice(indx, 1);
        } else {
          this.showDeletePopup = task.id;
        }
      } else {
        this.process.tasks.splice(indx, 1);
      }
    },

    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      });
    },
    duplicateProcess() {
      this.isDuplicating = true;
      const deepCopy = JSON.parse(JSON.stringify(this.process));

      // Add values to deepCopy
      deepCopy.id = this.newID();
      deepCopy.name = 'Kopie ' + deepCopy.name;

      // Modify display message
      this.tools.message = 'Kopie ';

      this.saveProcess(deepCopy);
    },
    changeWorkFlowNameInProcessList() {
      const currentProcessIndex = this.processList.findIndex(
        (singleProcess) => singleProcess.id === this.process.id
      );
      if (
        currentProcessIndex !== -1 &&
        this.processList[currentProcessIndex].name !== this.process.name
      )
        this.changeSingleFlowName({
          flowIndex: currentProcessIndex,
          newName: this.process.name,
        });
    },
    saveProcess() {
      this.unselectAllTasks();

      this.$store
        .dispatch('saveFlow', {
          flow: this.process,
        })
        .then((message) => {
          // Success always returns the ID as number
          if (typeof message == 'number') return message;
          else throw new Error(message);
        })
        .then(() => {
          this.changeWorkFlowNameInProcessList();
          this.isBrandSettingModelOpen = false;
          this.showToaster('Gespeichert !', 'Erfolgreich', 'success');
          this.activeAction = null;
          this.referenceProcess = JSON.stringify(this.flowWithoutInputOutput);
          return;
        })
        .catch((e) => {
          this.showToaster('Fehler beim Speichern !', 'Fehlerhaft !', 'danger');
          this.activeAction = null;
          this.requestError = e;
        });
    },
    showModalBox(error) {
      // Clear error first
      this.modalBox.msg.splice(0);

      this.$set(this.modalBox, 'isModalBoxVisible', true);
      this.$set(this.modalBox.msg, this.modalBox.msg.length, error);
    },
    hideModalBox() {
      this.$set(this.modalBox, 'isModalBoxVisible', false);
    },
    publishProcess() {
      this.activeAction = 'publishing';
      this.saveProcess();
    },
    hideHtmlViewer() {
      this.$set(this.htmlViewer, 'isHtmlViewerVisible', false);
    },
    closeDeletePopup() {
      this.showDeletePopup = '';
    },
    runProcess() {
      this.activeAction = 'running';

      //set API params
      var url = this.flowRunnerEndpoint;
      url += '/run_flow';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      // Deepcopy and empty all input/outputs
      var flow = JSON.parse(JSON.stringify(this.process));
      flow.tasks.forEach((part, index, arr) => {
        arr[index].output = [];
        arr[index].input = [];
      });

      // Create formdata
      let formData = new FormData();
      formData.append('flow', JSON.stringify(flow));
      // Put input in form data
      let props = this.process.tasks[0].props.formTrigger.elements;
      if (props.length > 0) {
        props.forEach((e) => {
          if (this.jsonTypes.includes(e.type))
            formData.append(e.name, JSON.stringify(e.value));
          else if (this.listTypes.includes(e.type)) {
            e.value.forEach((el) => formData.append(e.name, el));
          } else formData.append(e.name, e.value);
        });
      }

      // Put Files in form data
      if (this.process.tasks[0].output) {
        this.process.tasks[0].output.forEach((e) => {
          if (e.type == 'file') formData.append(e.name, e.value);
        });
      }

      //call api
      fetch(url, {
        body: formData,
        headers: myHeaders,
        method: 'POST',
      })
        .then(async (response) => {
          if (response.status == 200) return response.json();
          else if (response.status == 401)
            throw new Error('Access Token has expired');
          else {
            await response.json().then((json) => {
              throw { error: json.message };
            });
          }
        })
        .then((json) => {
          this.showToaster('Ausgeführt !', 'Erfolgreich', 'success');

          this.errorTask = null;
          this.errorDescription = null;
          this.activeAction = null;

          // Get last task from frontend & return
          let lastVue = this.process.tasks[this.process.tasks.length - 1];
          let lastJson = json[json.length - 1];

          // Add output to last task
          lastVue.output = lastJson.output;

          // Display the last task feedback
          this.$set(this.htmlViewer, 'html', lastJson.feedback);
          this.$set(this.htmlViewer, 'isHtmlViewerVisible', true);
        })
        .catch((e) => {
          if (e == 'Error: Access Token has expired') {
            localStorage.clear(),
              this.$router.push({
                name: 'auth',
                params: { message: 'Sitzung abgelaufen' },
              });
          } else {
            this.showToaster(
              JSON.parse(e.error)[`error`],
              'Fehlerhaft !',
              'danger'
            );
            this.errorTask = e.task;
            this.errorDescription = e.error;
            this.activeAction = null;
          }
        });
    },

    getShapeClass(task) {
      var arr = [
        task.shape.type,
        task.shape.selected ? 'selected' : '',
        this.hideDragArea === task.id ? 'dragging' : '',
        task.shape.selected ? 'dragging' : '',
      ];
      return arr;
    },

    changeFlowName(name) {
      this.process.name = name;
    },

    saveSettings(settings) {
      this.process.settings = settings;
    },

    addMissingAttributesToFlow() {
      // Add start task
      if (this.process.tasks.length == 0) {
        this.addTask(this.taskClasses[0]);
      }

      // Add structure to each element
      for (let el of this.process.tasks[0].props.formTrigger.elements) {
        if (!el.hasOwnProperty('structure')) {
          el.structure = { tab: 0, row: 0, col: 0 };
        }
      }

      // Add structure to task
      if (
        !this.process.tasks[0].props.formTrigger.hasOwnProperty('structure')
      ) {
        this.process.tasks[0].props.formTrigger.structure = {
          tabs: [
            {
              id: 0,
              rows: [
                {
                  id: 0,
                  cols: [
                    {
                      id: 0,
                    },
                  ],
                },
              ],
            },
          ],
        };
      }
    },

    checkRefreshToken() {
      if ((Date.now() - this.lastTokenRefresh) / 60000 > 15)
        this.refreshSession();
    },

    async refreshSession() {
      try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const currentSession = await Auth.currentSession();
        cognitoUser.refreshSession(
          currentSession.refreshToken,
          (err, session) => {
            // Replace user with new token
            let user = this.user;
            user.signInUserSession = session;

            // Set updated user
            this.$store.commit('setUser', user);

            // Set new refresh time
            this.lastTokenRefresh = Date.now();
            return session;
          }
        );
      } catch (e) {
        // Verification failed, log out
        this.$store.commit('setUser', null);
        return null;
      }
    },

    toggleUnderConstruction() {
      this.isUnderConstructionVisible = !this.isUnderConstructionVisible;
    },

    handleFileinputAtStart() {
      if (this.flowHasFileInput) {
        this.process.tasks[0].active = true;
      }
    },
    resetErrorMessage() {
      this.errorTask = null;
      this.errorDescription = null;
    },
    goBack() {
      if (this.hasUnsavedChanges) {
        if (
          window.confirm(
            'Sie haben ungespeicherte Daten, wollen Sie die Seite wirklich verlassen?'
          )
        ) {
          this.$router.push({
            path: '/',
            query: { section: 'flows', database: 'process-list' },
          });
        }
      } else {
        this.$router.push({
          path: '/',
          query: { section: 'flows', database: 'process-list' },
        });
      }
    },
    unselectAllTasks() {
      this.process.tasks.forEach((item) => (item.shape.selected = false));
    },
    findParentTask(task) {
      return this.process.tasks.find((item) => item.id === task.previousTaskId);
    },
    toggleEditCaption(id) {
      this.editCaptionTaskId = id;
      setTimeout(() => {
        if (id) this.$refs.taskCaption[0].focus();
      }, 100);
    },
    isAfterDropzoneVisible(index, task) {
      return (
        !this.process.tasks.some((item) => item.previousTaskId == task.id) &&
        !this.nonSwappableTasks.includes(task.name)
      );
    },
    createConnections(source, target) {
      jsPlumb.connect({
        source,
        target,
        anchors: ['Right', 'Left'],
        endpoints: [
          ['Rectangle', { width: 10, height: 10, cssClass: 'line-end-point' }],
          'Blank',
        ],
        paintStyle: { stroke: '#dddcdf', strokeWidth: 1.5 },
        connector: ['Flowchart', { cornerRadius: 5 }],
        overlays: [['Arrow', { location: 1 }]],
      });
    },
    setTaskConnection(tasks) {
      setTimeout(() => {
        jsPlumb.ready(() => {
          jsPlumb.reset();
          tasks.forEach((task, index, array) => {
            let source;
            if (task.pathType === false && this.process.tasks.length > 2)
              source = this.findParentTask(task);
            else source = array[index - 1];
            jsPlumb.draggable(this.$refs[task.id][0], {
              containment: true,
              getConstrainingRectangle: () => [99999, 99999],
              start: ({ e }) => {
                this.selectTask(task);
                task.shape.offsetx = e.clientX - task.shape.x;
                task.shape.offsety = e.clientY - task.shape.y;
              },
              drag: ({ e }) => {
                task.shape.x = e.clientX - task.shape.offsetx;
                task.shape.y = e.clientY - task.shape.offsety;
              },
            });

            if (source) {
              try {
                this.createConnections(
                  this.$refs[source.id][0],
                  this.$refs[task.id][0]
                );
              } catch (e) {
                // re-attempt to connect if fails
                this.createConnections(
                  this.$refs[source.id][0],
                  this.$refs[task.id][0]
                );
              }
            }
          });
        });
      }, 50);
    },
    isUserHasTaskEditAccess(task) {
      return ['Code', 'Condition', 'Logic', 'End'].includes(task.name)
        ? this.isUserHasAccess
        : true;
    },
    toggleBrandSettingModal() {
      this.isBrandSettingModelOpen = !this.isBrandSettingModelOpen;
    },
    saveBrandSettingsToProcess(newValues) {
      this.process = { ...this.process, style: newValues };
      this.activeAction = 'brandSettings';
      this.saveProcess();
    },
    downloadFlowAsJson() {
      // Copy and reset owner & tableID
      this.activeAction = 'downloading';
      try {
        const deepCopy = Object.assign(
          {},
          JSON.parse(JSON.stringify(this.process))
        );
        deepCopy.id = this.newID();
        deepCopy.owner = '';

        if (this.isTableIdArray) {
          deepCopy.tableID = [];
        }

        if (!this.isTableIdArray) {
          deepCopy.tableID = '';
        }

        // Remove input & output
        deepCopy.tasks.forEach((part, index, arr) => {
          arr[index].output = [];
          arr[index].input = [];
        });

        // Create data string & export
        const dataStr =
          'data:text/json;charset=utf-8,' +
          encodeURIComponent(JSON.stringify(deepCopy));
        const link = document.createElement('a');
        link.setAttribute('href', dataStr);
        link.setAttribute('download', deepCopy.name + '.json');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.activeAction = null;
      } catch (e) {
        this.activeAction = null;
      }
    },
    setShowResultInForm(value) {
      if (value) {
        this.process.tasks[0].props.formTrigger.structure.tabs[0].rows[0].cols.push(
          { id: 1 }
        );
      } else {
        if (
          !(
            this.process.tasks[0].props.formTrigger.structure.tabs[0].rows[0]
              .cols.length <= 1
          )
        ) {
          this.process.tasks[0].props.formTrigger.structure.tabs[0].rows[0].cols.pop();
        }
      }
    },
    toggleRemoveConfirmModal() {
      this.isRemoveConfirmVisible = !this.isRemoveConfirmVisible;
    },

    async removeFlow(id) {
      this.loading = true;
      //call api
      try {
        const deleteWorkflowResponse = await deleteWorkflowById(id);
        if (deleteWorkflowResponse.status == 200) {
          this.removeSingleFlowById(id);
          this.$router.push({
            name: 'home',
            query: { section: 'flows', database: 'process-list' },
          });
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.showToaster('etwas ist schief gelaufen', 'Fehler', 'danger');
        throw new Error(err);
      }
    },

    onConditionBuilderResponse(emittedData) {
      const conditionTask = this.process.tasks.find(
        (el) => el.id === emittedData.task.id
      );
      if (isObjectType(conditionTask))
        conditionTask.conditionResult = emittedData.res;
    },

    isNotConditionTaskPathExist(task) {
      return (
        isObjectType(task) && !('conditionResult' in task) && 'pathType' in task
      );
    },
  },
  created() {
    // Initiate time for token refresh
    this.lastTokenRefresh = Date.now();

    // Catch page refresh if flow is unsaved
    window.addEventListener(
      'beforeunload',
      (this.unsavedDataHandler = (event) => {
        if (this.hasUnsavedChanges) {
          return (event.returnValue =
            'Sie haben ungespeicherte Daten, wollen Sie die Seite wirklich verlassen?');
        }
      }),
      false
    );

    this.fetchData();
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.unsavedDataHandler, false);
    jsPlumb.destroy();
  },
  watch: {
    'process.tasks': {
      handler(newValue) {
        this.setTaskConnection(newValue);
      },
    },
  },
  computed: {
    ...mapGetters({ processList: 'getAllFlows' }),

    user() {
      return this.$store.state.user;
    },
    flowRunnerEndpoint() {
      if (
        this.process.settings.hasOwnProperty('apiEndpoint') &&
        this.process.settings.apiEndpoint != ''
      ) {
        return this.process.settings.apiEndpoint;
      } else return process.env.VUE_APP_FLOW_RUNNER_API;
    },
    flowHasFileInput() {
      return (
        this.process.tasks[0].props.formTrigger.elements.filter(
          (e) => e.type == 'file' || e.type == 'model'
        ).length > 0
      );
    },

    flowWithoutInputOutput() {
      var flow = Object.assign({}, JSON.parse(JSON.stringify(this.process)));
      flow.tasks.forEach((part, index, arr) => {
        arr[index].output = [];
        arr[index].input = [];
      });
      return flow;
    },
    hasUnsavedChanges() {
      let flows = [
        JSON.parse(this.referenceProcess),
        JSON.parse(JSON.stringify(this.flowWithoutInputOutput)),
      ];

      // Remove irrelevant data for comparisation
      flows.forEach((f) => {
        f.tasks.forEach((t) => {
          delete t.shape.offsetx;
          delete t.shape.offsety;
          delete t.shape.selected;
        });
      });
      return JSON.stringify(flows[0]) != JSON.stringify(flows[1]);
    },
    screenWidth() {
      const taskXValues = this.process.tasks.map((e) => e.shape.x);
      if (taskXValues.length > 0) return Math.max(...taskXValues) + 300 + 'px';
      else return '1000px';
    },
    screenHeight() {
      const taskYValues = this.process.tasks.map((e) => e.shape.y);
      if (taskYValues.length > 0) return Math.max(...taskYValues) + 300 + 'px';
      else return '1000px';
    },
    isTableIdArray() {
      if (typeof this.process.tableID === 'string') {
        return false;
      }

      if (Array.isArray(this.process.tableID)) {
        return true;
      }

      return null;
    },
    showDatabaseMissing() {
      const p = this.process;
      if (p.type == 'action') {
        if (p.hasOwnProperty('tableID')) {
          // Check if database exists
          let database;

          if (this.isTableIdArray) {
            database = this.databases.find((e) =>
              p.tableID.includes(e.name.trim())
            );
          }

          if (!this.isTableIdArray) {
            database = this.databases.find((e) => e.name == p.tableID);
          }

          if (database != undefined) return false;
          else {
            // No database selected or database not found
            if (this.isTableIdArray) {
              p.tableID = [];
            }

            if (!this.isTableIdArray) {
              p.tableID = '';
            }
            return true;
          }
        } else {
          // Add tableID prop for backwards compatibilty
          if (this.isTableIdArray) {
            p.tableID = [];
          }

          if (!this.isTableIdArray) {
            p.tableID = '';
          }
          return true;
        }
      } else return false;
    },
    databaseSchema() {
      const process = this.process;
      if (process.type == 'action' && process.hasOwnProperty('tableID')) {
        // Return schema if found else null
        try {
          if (this.isTableIdArray) {
            return JSON.parse(
              this.databases.find((e) => e.name == process.tableID[0]).schema
            );
          }

          if (!this.isTableIdArray) {
            return JSON.parse(
              this.databases.find((e) => e.name == process.tableID).schema
            );
          }
        } catch {
          return null;
        }
      }
      return null;
    },
    isUserHasAccess() {
      return (
        this.flowPermission.access_level != workFlowAccessLevel.EDIT_CONTENT
      );
    },
  },
  components: {
    Start,
    Database,
    TsOperations,
    Pricing,
    AddValue,
    Email,
    API,
    Code,
    End,
    Ftp,
    InputBox,
    ReadTS,
    TSMath,
    HTML,
    UnderConstruction,
    htmlViewer,
    PageBuilder,
    Condition,
    deleteConditionModal,
    LoadingSpinner,
    Logic,
    BrandSettingModel,
    RemoveConfirmModal,
    Redirect,
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventOnClick = function (event) {
          // Check that the click was outside the el and its children
          if (!(el == event.target || el.contains(event.target))) {
            // call method provided in attribute value
            vnode.context[binding.expression]();
          }
        };
        document.addEventListener('click', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('click', el.eventOnClick);
      },
    },
  },
};
</script>

<style scoped>
::v-deep html,
body,
#app {
  background-color: red;
  background: red;
}

.wrapper {
  min-width: 1500px;
  width: fit-content;
  min-height: 100%;
  background: #fafafb;
  min-width: 100%;
  z-index: 500;
}

.process {
  width: fit-content;
  position: relative;
  top: 75px;
  left: 230px;
  min-width: 500px;
  min-height: 500px;
  max-height: calc(100vh - 80px);
  overflow: auto;
  max-width: calc(100vw - 315px);
  box-sizing: border-box;
  padding: 55px 10px 10px 50px;
}

.upper-bar {
  position: fixed;
  width: 100%;
  height: 74px;
  border-bottom: 1px solid #eaeaea;
  z-index: 2;
  background-color: #fafafb;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn-back {
  font-size: 19px;
  background: #4b4b4d;
  color: #ffff;
  width: 48px;
  height: 48px;
  border-radius: 7px;
  cursor: pointer;
  margin-left: 30px;
}

.btn-back:hover {
  background: #eaeaee;
  color: #4b4b4d;
  border: none;
}

.btn-back a {
  color: #ffff;
}

.name-wrapper {
  border-left: 1px solid #eaeaea;
  padding-left: 20px;
  margin-left: 20px;
  height: 100%;
  display: flex;
  align-items: center;
}

.name-wrapper input {
  background: #fafafb;
  color: #444f62;
  font-size: 16px;
  text-align: left;
  height: 92%;
  font-weight: 400;
  letter-spacing: 0.5px;
  cursor: text;
}

.toolbar {
  margin: 0;
  width: 20%;
}

.toolbar.container .row {
  justify-content: end;
}

.toolbar .btn-group {
  display: inline-grid;
}

.toolbar .btn-group .button {
  display: flex;
  margin-right: 12px;
  opacity: 0.93;
  border-radius: 50px;
  height: 45px;
  width: 45px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 19px;
  cursor: pointer;
}

.toolbar .button {
  color: #ffff;
  background: #3d3d3f;
}

.toolbar .button.deploy {
  color: #ffff;
  background: rgb(255, 51, 102);
}

.toolbar .btn-group .button-loading::after {
  content: '';
  position: absolute;
  width: 47px;
  height: 47px;
  border: 2px solid transparent;
  border-top-color: #3c3d3e;
  border-radius: 50%;
  -webkit-animation: button-loading-spinner 1s ease infinite;
  animation: button-loading-spinner 1s ease infinite;
  top: -3px;
  left: -3px;
  right: 0;
  bottom: 0;
}

@keyframes button-loading-spinner {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}

.message {
  color: #6cbd7c;
  font-size: 14px;
  font-family: sans-serif;
  margin-top: 15px;
  padding-left: 4px;
  min-height: 20px;
}

.message.error {
  color: #df0025;
}

.palette {
  text-align: center;
  display: block;
  transform: translate(-50%, 1%);
  transform-origin: 0 0;
  box-shadow: 0 0 20px rgb(31 37 50 / 20%);
  width: 250px;
  position: fixed;
  left: 25px;
  margin: 0;
  border-radius: 13px;
  background: #ffff;
  overflow: auto;
  top: calc(50% + 35px);
  height: 70vh;
  transform: translateY(-50%);
  padding: 56px 20px 20px 28px;
}

.palette .shape {
  position: relative;
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.2);
}

.palette .task {
}

.palette .caption {
  padding-left: 15px;
}

.process .task-wrapper {
  position: absolute;
}
.palette .task-wrapper {
  margin-bottom: 80px;
  display: flex;
  align-items: center;
}

.process .task-wrapper.error .shape.task {
  box-shadow: 0px 0px 12px 6px rgb(255 0 0 / 56%);
}

.task-wrapper .shape img {
  max-width: 25px;
  position: relative;
  top: -7px;
}

.process .task-wrapper .condition-state {
  position: absolute;
  top: -70px;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: block;
  font-size: 16px;
  color: green;
  text-transform: uppercase;
  font-weight: 700;
}

.process .task-wrapper .condition-state.false {
  color: red;
}

.task {
  text-align: center;
  padding: 25px;
  cursor: pointer;
  font-weight: 100;
  color: #424956;
  font-size: 16px;
  line-height: inherit;
  margin-top: 0px;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
}

[disabled] {
  opacity: 0.5;
  cursor: not-allowed !important;
}
.task:hover:not([disabled]) {
  transform: scale(1.1);
  box-shadow: 0 0 0 1px rgb(0 0 0 / 5%), 0 10px 20px rgb(0 0 0 / 15%);
}

.shape {
  border: 1px solid #e5eaf4;
  border: 0;
  border-radius: 4px;
  background: #fff;
  -webkit-box-shadow: 0 1px 1px rgba(51, 60, 78, 0.06);
  box-shadow: 0 0 8px rgba(31, 37, 50, 0.2);
  transform: translateZ(0);
  cursor: pointer;
  outline: 0;
  font-size: 25px;
  color: #3c3d3e;
}

.shape.circle {
  width: 85px;
  height: 85px;
  border-radius: 50%;
  font-size: 26px;
  line-height: 37px;
  padding-left: 28px;
  text-align: center;
}

.shape.rectangle {
  width: 85px;
  height: 78px;
  border-radius: 5px;
  font-size: 14px;
  font-size: 25px;
}
.shape.dragging {
  z-index: 9;
}

.caption {
  text-align: left;
  width: 100px;
  font-size: 15px;
  color: #444f62;
  font-weight: 500;
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  text-transform: uppercase;
}

.custom-drag-area {
  position: absolute;
  top: 0;
  height: 76px;
  width: 78px;
  border: 1.5px #c8c5c5;
  background: #8080800d;
  border-radius: 5px;
  border-style: dashed;
  font-size: 14px;
  line-height: 84px;
  color: #979696;
  opacity: 0;
  visibility: hidden;
}

.custom-drag-area.before {
  left: -89px;
}
.custom-drag-area.after {
  left: 90px;
}

.custom-drag-area.true {
  right: -89px;
  top: -45px;
}

.custom-drag-area.false {
  right: -89px;
  top: 45px;
}

/* .shape:hover .custom-drag-area, */
.dropped-task-class {
  visibility: visible;
  opacity: 1;
}

.shape.task.rectangle.dragging .custom-drag-area {
  opacity: 0;
  visibility: hidden;
}

.custom-drag-area .icon {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.tools {
  color: #a4abb1;
  position: absolute;
  left: -3px;
  top: 94px;
  z-index: 2;
  border: 0px solid transparent;
  height: 10px;
  list-style: none;
  display: flex;
}

.tools li {
  display: inline;
  float: left;
  list-style: none;
  cursor: pointer;
  padding: 0;
  margin: 0 0 0 8px;
  font-size: 13px;
}

.tools li > a {
  zoom: 1.2;
  opacity: 0.7;
  width: auto;
  height: auto;
  display: block;
  transition: opacity 0.2s ease-in-out;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
  text-indent: 0;
}

.tools li > a:hover {
  color: #1f2532;
}

::v-deep .modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .modal.task {
  position: fixed;
  background: #ffffff;
  height: 98%;
  display: block;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #9f9f9f;
  border: solid 0.05px #c3c4c6;
  border-radius: 13px;
  box-shadow: 0 1px 10px rgb(0 0 0 / 15%), 0 2.4px 5.7px rgb(0 0 0 / 2%),
    0 4px 11.3px rgb(0 0 0 / 2%), 0 10.6px 17.5px rgb(0 0 0 / 2%),
    0 14px 25.7px rgb(0 0 0 / 3%), 0 35.5px 39.6px rgb(0 0 0 / 4%),
    0 40px 48px rgb(0 0 0 / 3%);
  left: 0;
  right: 0;
  margin-right: auto;
  margin-left: auto;
  width: 90%;
}

::v-deep .modal.task .tools {
  position: relative;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 46px;
  height: 199px;
  top: -65%;
  float: right;
}

::v-deep .modal.task .element {
  margin-bottom: 16px;
  height: 46px;
  width: 46px;
}

::v-deep .modal.task .tools .element .button {
  background-color: var(--color-black-lighter);
  fill: #fff;
  stroke: #fff;
  width: 46px;
  height: 46px;
  border-radius: var(--circled);
  border: 0;
  -webkit-box-shadow: var(--elevation-medium);
  box-shadow: var(--elevation-low);
  transform: translateZ(0);
  cursor: pointer;
  outline: 0;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  padding: 0;
  transition: all 0.3s ease-out;
}

::v-deep .modal.task .tools .element .button:hover {
  fill: var(--color-black-lighter);
  stroke: var(--color-black-lighter);
  background: #fff;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
}

::v-deep .modal.task .tools .element .button:hover svg {
  border: none;
}

::v-deep .modal.task .paper-clip {
  padding-top: 5px;
}

::v-deep .modal.task .data-fields {
  margin-top: 10px;
}

::v-deep .modal.task .action {
  margin-top: 24px;
}

::v-deep .modal.task .tools .element:hover .info-wrapper {
  display: block;
}

::v-deep .modal.task .info-wrapper {
  position: relative;
  display: none;
  will-change: opacity, visibility;
  -webkit-transition: visibility 0.2s cubic-bezier(0.2, 0.91, 0.85, 0.96) 0.35s,
    opacity 0.2s cubic-bezier(0.2, 0.91, 0.85, 0.96) 0.35s;
  transition: visibility 0.2s cubic-bezier(0.2, 0.91, 0.85, 0.96) 0.35s,
    opacity 0.2s cubic-bezier(0.2, 0.91, 0.85, 0.96) 0.35s;
  margin-top: 0;
  right: 133px;
  top: -39px;
  z-index: 1;
  width: fit-content;
}

::v-deep .modal.task .info-wrapper .info {
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  letter-spacing: 0.125px;
  white-space: nowrap;
  color: white;
  background: rgb(23, 25, 29);
  border-radius: 4px;
  padding: 8px 16px;
}

::v-deep .modal.task .toggle-list-wrapper {
  background-color: #ffff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  right: 249px;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
  max-width: 600px;
  overflow: scroll;
  z-index: 1;
  margin-top: -93px;
  top: -56px;
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 6px;
  width: 226px;
  margin-top: 0px;
  margin-right: 0px;
  overflow: scroll;
  height: 250px;
  left: auto;
}

::v-deep .modal.task .toggle-list-wrapper.data-fields {
  border-radius: 3px;
  display: inline-block;
  padding: 16px 0;
  width: 226px;
  margin-top: 0px;
  overflow-y: auto;
  height: 250px;
  box-sizing: border-box;
}

::v-deep .modal.task .toggle-list-wrapper .item {
  height: 135px;
  cursor: pointer;
  padding: 8px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

::v-deep .modal.task .toggle-list-wrapper.data-fields .item {
  cursor: pointer;
  border: none;
  height: auto;
  padding: 8px;
  text-align: center;
  margin: 0 auto;
  width: 200px;
  box-sizing: border-box;
}

::v-deep .modal.task .toggle-list-wrapper.data-fields .item:hover,
.toggle-list-wrapper.actions .item:hover {
  background: #f0f0f0;
}

::v-deep .modal.task .toggle-list-wrapper.data-fields .item .label,
.toggle-list-wrapper.actions .item .label {
  font-weight: 300;
  color: #464d5d;
}

::v-deep .modal.task .toggle-list-wrapper .item .label {
  overflow: hidden;
  font-size: 12px;
  text-transform: none;
  padding: 0;
  margin: 0;
  margin-top: 0;
  height: auto;
  padding-left: 14px;
  padding-right: 14px;
  color: #596377;
  font-size: 14px;
  box-sizing: border-box;
  line-height: 30px;
}

.tools .element:hover .info-wrapper {
  display: block;
}

.info-wrapper {
  position: absolute;
  display: none;
  will-change: opacity, visibility;
  transition: visibility 0.2s cubic-bezier(0.2, 0.91, 0.85, 0.96) 0.35s,
    opacity 0.2s cubic-bezier(0.2, 0.91, 0.85, 0.96) 0.35s;
  margin-top: -38px;
  right: 59px;
}

.info-wrapper .info {
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  letter-spacing: 0.125px;
  white-space: nowrap;
  color: white;
  background: rgb(23, 25, 29);
  border-radius: 4px;
  padding: 8px 16px;
}

.toggle-list-wrapper.data-fields {
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 0px;
  margin-left: -186px;
  overflow: scroll;
  max-height: 250px;
}

.toggle-list-wrapper.actions {
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 0px;
  margin-left: -185px;
  overflow: scroll;
  max-height: 250px;
}

.toggle-list-wrapper .item {
  height: 135px;
  cursor: pointer;
  padding: 8px;
  width: 130px;
  text-align: center;
}

.modal.task .toggle-list-wrapper.data-fields .item,
.modal.task .toggle-list-wrapper.actions .item {
  width: 100%;
  text-align: left;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  font-weight: 300;
  margin: 0;
  padding: 0;
}

.toggle-list-wrapper.data-fields .item:hover,
.toggle-list-wrapper.actions .item:hover {
  background: #f0f0f0;
}

.toggle-list-wrapper.data-fields .item .label,
.toggle-list-wrapper.actions .item .label {
  font-weight: 300;
  color: #464d5d;
  margin: 0;
}

.toggle-list-wrapper .item .label {
  overflow: hidden;
  font-size: 12px;
  text-transform: none;
  padding: 0;
  margin: 0;
  margin-top: 11px;
  height: 44px;
  padding-left: 14px;
  padding-right: 14px;
  color: #596377;
}

.error-message {
  opacity: 0;
  position: absolute;
}

.error-icon:hover .error-message {
  opacity: 1;
  width: 100px;
  color: #fff;
  background: #353535;
  font-weight: 400;
  padding: 14px;
  border-radius: 6px;
  margin-top: 7px;
  margin-left: 5px;
}

.danger {
  color: #ff4572;
}

.selected {
  color: #f0436f !important;
  box-shadow: 0 0 8px #ff9bbe !important;
}

.process-inner {
  width: 100%;
  height: 100%;
  position: relative;
}

.task-caption {
  /* position: absolute;
  text-align: center;
  width: auto;
  height: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  color: #464d5d;
  left: 0;
  right: 0;
  top: -28px;
  cursor: text;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden; */

  position: absolute;
  text-align: center;
  width: 200px;
  height: 50px;
  display: -webkit-box;
  display: -ms-flexbox;
  /* display: flex; */
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  color: #464d5d;
  left: -56px;
  top: -55px;
  cursor: text;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.task-caption .title {
  background-color: transparent;
  padding: 0;
  font-size: 16px;
  color: #464d5d;
  margin: 0;
  font-weight: 400;
  line-height: 50px;
  -webkit-font-smoothing: antialiased;
  border: 0;
  width: 100%;
  height: 24px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 2px;
  text-align: center;
  outline: none;
  cursor: text;
  font-family: var(--bs-body-font-family);
}

/* dragged element */
.jtk-dragged {
  z-index: 1;
}
::v-deep .line-end-point svg rect {
  fill: #dddcdf !important;
}
::v-deep .line-end-point {
  margin-left: 5px;
}

/* loader postion */
.process-loading {
  width: 100%;
  height: 100%;
  background: #fff;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 1;
}

.process-loading .progress-icon {
  top: 50%;
  transform: translateY(-50%);
  height: fit-content;
  width: fit-content;
  left: 0;
  right: 0;
  margin: 0 auto;

  position: absolute;
}

.process-loading .progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #313745;
  border-color: #313745 transparent #313745 transparent;
  animation: progress-icon 1.2s linear infinite;
}

/*Topbar*/
.workflow-lefttop-bar {
  display: flex;
  align-items: center;
  height: 100%;
}
::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}
</style>
